export const RENTLINX_EXPERIMENT_VARIANT_SPECIAL_DEAL_YES = 'yes';
export const RENTLINX_EXPERIMENT_VARIANT_SPECIAL_DEAL_NO = 'no';

export const RENTLINX_LISTING_LEAD_STATUS_ACTIVE = 'active';
export const RENTLINX_LISTING_LEAD_STATUS_ARCHIVED = 'archived';

export const RENTLINX_UNIT_LIMIT = 1000;

export const RENTLINX_LISTING_LEAD_QUALIFIED_ARCHIVE_REASON_VALUES = [
  'acceptedAnotherListing',
  'doesntLikeTheArea',
  'missingAppliances',
  'noLongerInTown',
  'noResponse',
  'partnerAcceptedAnotherApp',
  'submittedAnotherApp',
];

export const RENTLINX_LISTING_LEAD_UNQUALIFIED_ARCHIVE_REASON_VALUES = [
  'accidentalLead',
  'doesntQualify',
  'moveInDateDoesntMatch',
  'notPetFriendly',
  'priceTooHigh',
  'duplicate',
];

export const RENTLINX_LISTING_LEAD_HIGHLIGHT_ARCHIVE_REASON_VALUES = [
  'needsSection8',
  'creditScoreLow',
  'dogBreed',
  'tooManyPets',
  'recentBankruptcy',
  'recentEviction',
  'recentCrime',
  'kitchenOld',
  'homeInPoorCondition',
  'priceTooHigh',
  'missingAppliances',
  'notPetFriendly',
];

export const RENTLINX_LISTING_LEAD_ARCHIVE_REASON_OPTION_ITEMS = [
  {
    label: 'Accepted another listing',
    value: 'acceptedAnotherListing',
  },
  {
    label: 'Accidental Lead',
    value: 'accidentalLead',
  },
  {
    label: 'Doesn’t like the area',
    value: 'doesntLikeTheArea',
  },
  {
    label: 'Doesn’t qualify',
    value: 'doesntQualify',
  },
  {
    label: 'Missing appliance(s)',
    value: 'missingAppliances',
  },
  {
    label: 'Move in date doesn’t match',
    value: 'moveInDateDoesntMatch',
  },
  {
    label: 'No longer in town',
    value: 'noLongerInTown',
  },
  {
    label: 'Lead unresponsive',
    value: 'noResponse',
  },
  {
    label: 'Not pet friendly',
    value: 'notPetFriendly',
  },
  {
    label: 'Partner accepted another app',
    value: 'partnerAcceptedAnotherApp',
  },
  {
    label: 'Price too high',
    value: 'priceTooHigh',
  },
  {
    label: 'Submitted another app',
    value: 'submittedAnotherApp',
  },
  {
    label: 'Other',
    value: 'other',
  },
];
